import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators'

export const getRates = request('RATES/GET', ({ protrackId, levelId }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/${levelId}/rates`,
  },
}))

export const selectPage = createAction('RATES/SELECT_PAGE', page => ({
  page,
}))
